import { render } from "./Temple.vue?vue&type=template&id=7b5679f2"
import script from "./Temple.vue?vue&type=script&lang=js"
export * from "./Temple.vue?vue&type=script&lang=js"

import "./Temple.vue?vue&type=style&index=0&id=7b5679f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__